// src/api/apiService.js

// Fetch menu details
export async function getMenuDetails(eatsStoreId) {
  const accessToken = localStorage.getItem('accessToken');
  if (!accessToken) throw new Error('Access token is missing.');

  const response = await fetch(`/api/v2/eats/stores/${eatsStoreId}/menus`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) throw new Error('Failed to fetch menu details');
  return await response.json();
}

// Update menu details
export const updateMenuDetails = async (eatsStoreId, menuData) => {
  console.log("Store ID (eatsStoreId):", eatsStoreId, "Type:", typeof eatsStoreId); // Debugging

  if (!eatsStoreId || typeof eatsStoreId !== "string") {
    throw new Error("Invalid Store ID. It must be a string.");
  }
  const accessToken = localStorage.getItem('accessToken');
  const url = `/api/v2/eats/stores/${eatsStoreId}/menus`;
  console.log(menuData);

  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(menuData),
  });

  if (!response.ok) {
    throw new Error('Failed to update menu details');
  }

  return response; // Return the response for `.then()` in the caller
};


